<template>
  <div class="dept_container">
    <div class="department_title">
      角色查询
    </div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="角色名称：">
        <el-input
          v-model="formInline.roleName"
          placeholder="请输入角色名称"
          clearable
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="状态：" class="left_margin">
        <el-select v-model="formInline.status" placeholder="角色状态" clearable>
          <el-option label="正常" value="0"></el-option>
          <el-option label="停用" value="1"></el-option>
        </el-select>
      </el-form-item> -->
      <!-- 时间选择器 -->
      <!-- <el-form-item label="创建时间：" class="left_margin">
        <el-date-picker
          v-model="time"
          value-format="yyyy-MM-dd"
          type="daterange"
          size="small"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="left"
          prefix-icon="el-icon-date"
        >
        </el-date-picker>
      </el-form-item> -->
      <el-form-item class="left_margin">
        <el-button type="primary" @click="onSubmit" class="inquire"
          >搜索</el-button
        >
        <el-button type="primary" class="reset" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="newly_built">
      <el-button
        type="primary"
        icon="el-icon-plus"
        class="newly_built_btn"
        @click="new_construction"
        v-if="premission('system:role:add')"
        >新建</el-button
      >
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      style="width: 100%"
      lazy
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="roleName" label="角色名称" width="180">
      </el-table-column>
      <el-table-column prop="roleSort" label="排序" width="180">
      </el-table-column>
      <!-- <el-table-column prop="roleKey" label="数据权限" width="180">
      </el-table-column> -->
      <el-table-column prop="createBy" label="修改人" width="180">
      </el-table-column>
      <el-table-column prop="createTime" label="修改日期" width="180">
      </el-table-column>
      <el-table-column prop="remark" label="备注" width="180">
      </el-table-column>
      <el-table-column prop="createTime" label="是否显示" width="180">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#F6B439"
            inactive-color="#ff4949"
            active-value="0"
            inactive-value="1"
            @change="switch_value_btn(scope.row)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="数据权限">
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="scope.row.dataScope == 0"
            @click="Datapermission(scope.row)"
            style="color:#EB5757"
            >未添加</el-button
          >
          <el-button
            type="text"
            v-if="scope.row.dataScope == 1"
            @click="Datapermission(scope.row)"
            >本公司及以下</el-button
          >
          <el-button
            type="text"
            v-if="scope.row.dataScope == 2"
            @click="Datapermission(scope.row)"
            >自定义数据权限</el-button
          >
          <el-button
            type="text"
            v-if="scope.row.dataScope == 3"
            @click="Datapermission(scope.row)"
            >本部门数据权限</el-button
          >
          <el-button
            type="text"
            v-if="scope.row.dataScope == 4"
            @click="Datapermission(scope.row)"
            >本公司</el-button
          >
          <el-button
            type="text"
            v-if="scope.row.dataScope == 5"
            @click="Datapermission(scope.row)"
            >仅本人数据权限</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作">
        <template slot-scope="scope">
          <!-- <el-button
            type="text"
            class="operation_right"
            icon="el-icon-remove-outline"
            >查看</el-button
          > -->
          <el-button
            type="text"
            class="operation_right"
            icon="el-icon-edit-outline"
            @click="compile(scope.row)"
            v-if="premission('system:role:edit')"
            >编辑</el-button
          >
          <el-button
            type="text"
            icon="el-icon-delete"
            @click="Delete(scope.row)"
            v-if="premission('system:role:remove')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增角色弹窗 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="820px"
      :before-close="handleClose"
    >
      <el-form
        ref="menu"
        :model="sizeForm"
        :rules="rules"
        label-width="110px"
        size="mini"
      >
        <el-form-item label="角色名称：" prop="roleName">
          <el-input
            v-model="sizeForm.roleName"
            placeholder="请添加角色名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序：" prop="roleSort">
          <el-input
            v-model="sizeForm.roleSort"
            placeholder="请填写排序,数字越小越靠前"
          ></el-input>
        </el-form-item>
        <el-form-item label="菜单权限：" class="WeChat">
          <el-tree
            class="tree-border"
            :data="treeselectList"
            show-checkbox
            ref="menus"
            node-key="id"
            empty-text="加载中，请稍后"
            :props="defaultProps"
            :check-strictly="false"
          ></el-tree>
          <!-- :default-checked-keys="menuList"
            @check="handleCheckChangeOne" -->
        </el-form-item>
        <el-form-item label="显示状态：">
          <el-radio v-model="sizeForm.status" label="0">显示</el-radio>
          <el-radio v-model="sizeForm.status" label="1">不显示</el-radio>
        </el-form-item>
        <el-form-item label="备注：" class="WeChat">
          <el-input
            type="textarea"
            :rows="2"
            maxlength="10"
            show-word-limit
            placeholder="请输入内容"
            v-model="sizeForm.remark"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDataScope" class="cancel">取 消</el-button>
        <el-button type="primary" @click="add_new_btn" class="add_new_btn"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 数据权限按钮 -->
    <el-dialog
      title="分配数据权限"
      :visible.sync="dialogVisibleData"
      width="820px"
      :before-close="handleClose"
    >
      <el-form ref="dept" :model="Form" label-width="110px" size="mini">
        <el-form-item label="角色名称：">
          <el-input
            v-model="Form.roleName"
            placeholder="请添加角色名称"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="数据权限：">
          <el-radio v-model="Form.dataScope" label="5">仅自己</el-radio>
          <el-radio v-model="Form.dataScope" label="3">仅本部门</el-radio>
          <!-- <el-radio v-model="Form.dataScope" label="4">仅本公司</el-radio> -->
          <el-radio v-model="Form.dataScope" label="1">仅本公司以下</el-radio>
          <el-radio v-model="Form.dataScope" label="2">自定义</el-radio>
        </el-form-item>
        <el-form-item
          label="数据权限："
          class="WeChat"
          v-show="this.Form.dataScope == 2"
        >
          <el-tree
            class="tree-border"
            :data="roleDeptTreeselectList"
            show-checkbox
            ref="depts"
            node-key="id"
            empty-text="加载中，请稍后"
            :props="defaultProps"
            :check-strictly="false"
          ></el-tree>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDataScope" class="cancel">取 消</el-button>
        <el-button type="primary" @click="deptBtn" class="add_new_btn"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 分页 -->
    <div class="paging">
      <div class="block">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[8, 16, 24, 32]"
          :page-size="8"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import premission from "../../utils/permission";
import {
  dataScope,
  updateRole,
  addRole,
  getRole,
  changeRoleStatus,
  roleMenuTreeselect,
  roleDeptTreeselect,
  RoleListsAjax,
  RoleDeleteAjax,
  RoleTreeselectAjax
} from "../../api/index";
import { addDateRange } from "../../utils/treating";
export default {
  mixins: [premission],
  data() {
    return {
      // 时间返回数据
      // time: [],
      // pickerOptions: {
      //   shortcuts: [
      //     {
      //       text: "最近一周",
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      //         picker.$emit("pick", [start, end]);
      //       }
      //     },
      //     {
      //       text: "最近一个月",
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      //         picker.$emit("pick", [start, end]);
      //       }
      //     },
      //     {
      //       text: "最近三个月",
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      //         picker.$emit("pick", [start, end]);
      //       }
      //     }
      //   ]
      // },
      // 节流阀
      throttle: "true",
      // 是否显示
      // switch_value: false,
      // 新建角色弹窗
      dialogVisible: false,
      // 修改数据权限
      dialogVisibleData: false,
      // 搜索数据
      title: "",
      roleList: [],
      menuList: [],
      formInline: {
        pageNum: 1,
        pageSize: 8,
        roleName: undefined,
        status: undefined
      },
      currentPage: 1,
      total: 0,
      Form: {
        roleName: "",
        dataScope: "",
        deptIds: []
      },
      // 新建按钮获取数据
      treeselectList: [],
      // 编辑的数据树
      roleDeptTreeselectList: undefined,
      // 新建角色数据
      sizeForm: {
        menuIds: [],
        roleName: "",
        roleSort: "",
        remark: "",
        status: "0",
        dataScope: "0",
        roleKey: "123",
        menuCheckStrictly: true,
        deptCheckStrictly: true
      },
      // 表单数据
      tableData: [],
      // 表单参数
      form: {},
      defaultProps: {
        children: "children",
        label: "label"
      },
      // 表单校验
      rules: {
        roleName: [
          { required: true, message: "角色名称不能为空", trigger: "blur" }
        ],

        roleSort: [
          { required: true, message: "角色顺序不能为空", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.getRoleListsAjax();
  },
  methods: {
    // 所有菜单节点数据
    getMenuAllCheckedKeys() {
      // 目前被选中的菜单节点
      let checkedKeys = this.$refs.menus.getCheckedKeys();
      // 半选中的菜单节点
      let halfCheckedKeys = this.$refs.menus.getHalfCheckedKeys();
      checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
      return checkedKeys;
    },
    // 所有部门节点数据
    getDeptAllCheckedKeys() {
      // 目前被选中的部门节点
      let checkedKeys = this.$refs.depts.getCheckedKeys();
      // 半选中的部门节点
      let halfCheckedKeys = this.$refs.depts.getHalfCheckedKeys();
      checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
      return checkedKeys;
    },
    //搜索
    async onSubmit() {
      const { data: res } = await RoleListsAjax(
        addDateRange(this.formInline, this.time)
      );
      if (res.code !== 200)
        return this.$message({
          message: res.msg,
          type: "error"
        });
      this.tableData = res.rows;
      this.total = res.total;
    },
    // 获取角色详情
    async getRoleAjax(row) {
      const { data: res } = await getRole(row.roleId);
      this.Form = res.data;
      this.sizeForm = res.data;
    },
    // 数据权限
    async roleDeptTreeselectAjax(row) {
      const { data: res } = await roleDeptTreeselect(row.roleId);
      this.roleDeptTreeselectList = res.depts;
      this.roleList = res.checkedKeys;
      this.Form.deptIds = res.checkedKeys;
      this.$nextTick(() => {
        this.$refs.depts.setCheckedKeys(res.checkedKeys);
      });
    },
    // 重置
    reset() {
      this.formInline.status = undefined;
      this.formInline.roleName = undefined;
      this.time = [];
      this.getRoleListsAjax();
    },
    // 获取表单数据
    async getRoleListsAjax() {
      const { data: res } = await RoleListsAjax(this.formInline);
      if (res.code !== 200)
        return this.$message({
          message: res.msg,
          type: "error"
        });
      this.tableData = res.rows;
      this.total = res.total;
    },
    // 获取新建按钮树形结构数据
    async getRoleTreeselectAjax() {
      const { data: res } = await RoleTreeselectAjax();
      if (res.code !== 200)
        return this.$message({
          message: res.msg,
          type: "error"
        });
      this.treeselectList = res.data;
    },
    /** 查询部门树结构 */
    getDeptTreeselect() {
      deptTreeselect().then(response => {
        this.deptOptions = response.data;
      });
    },
    // 新建按钮
    new_construction() {
      this.title = "新建角色";
      this.dialogVisible = true;
      this.getRoleTreeselectAjax();
    },
    // 编辑
    compile(row) {
      this.title = "编辑角色";
      this.dialogVisible = true;
      this.getRoleAjax(row);
      this.getRoleTreeselectAjax();
      this.roleMenuTreeselectAjax(row);
    },
    async roleMenuTreeselectAjax(row) {
      const { data: res } = await roleMenuTreeselect(row.roleId);
      this.$nextTick(() => {
        this.$refs.menus.setCheckedKeys(res.checkedKeys);
      });
      this.menuList = res.checkedKeys;
      this.sizeForm.menuIds = res.checkedKeys;
    },
    // 新建弹出框公司
    add_new_btn() {
      if (!this.throttle) return;
      this.throttle = false;
      this.$refs.menu.validate(async valid => {
        if (valid) {
          if (this.title == "新建角色") {
            this.sizeForm.menuIds = this.getMenuAllCheckedKeys();
            const { data: res } = await addRole(this.sizeForm);
            if (res.code !== 200) {
              return this.$message({
                message: res.msg,
                type: "error"
              });
            } else {
              this.dialogVisible = false;
              this.getRoleListsAjax();
              this.throttle = true;
              this.sizeForm = {
                roleName: "",
                roleSort: "",
                remark: "",
                status: "1",
                roleKey: "123",
                menuIds: []
              };
              this.roleList = [];
              this.menuList = [];
              return this.$message({
                message: res.msg,
                type: "success"
              });
            }
          }
          if (this.title == "编辑角色") {
            this.sizeForm.menuIds = this.getMenuAllCheckedKeys();
            const { data: res } = await updateRole(this.sizeForm);
            if (res.code !== 200) {
              return this.$message({
                message: res.msg,
                type: "error"
              });
            } else {
              this.dialogVisible = false;
              this.getRoleListsAjax();
              this.throttle = true;
              this.sizeForm = {
                roleName: "",
                roleSort: "",
                remark: "",
                status: "1",
                roleKey: "123",
                menuIds: []
              };
              this.roleList = [];
              this.menuList = [];
              return this.$message({
                message: res.msg,
                type: "success"
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 数据权限确认按钮
    async deptBtn() {
      if (!this.throttle) return;
      this.throttle = false;
      this.Form.deptIds = this.getDeptAllCheckedKeys();
      const { data: res } = await dataScope(this.Form);
      if (res.code !== 200) {
        return this.$message({
          message: res.msg,
          type: "error"
        });
      } else {
        this.dialogVisibleData = false;
        this.getRoleListsAjax();
        this.throttle = true;
        this.Form = {
          roleName: "",
          dataScope: "",
          deptIds: []
        };
        this.roleList = [];
        this.menuList = [];
        return this.$message({
          message: res.msg,
          type: "success"
        });
      }
    },
    // 新建公司弹窗确认和取消
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
          this.sizeForm = {
            roleName: "",
            roleSort: "",
            remark: "",
            status: "1",
            roleKey: "123",
            menuIds: []
          };
        })
        .catch(_ => {});
    },
    handleSelectionChange(val) {
      console.log(val);
    },
    // 删除部门
    Delete(e) {
      this.open(e);
    },
    open(e) {
      this.$confirm(`是否确认删除名称为"${e.roleName}"的数据项？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",

        type: "warning"
      })
        .then(async () => {
          const { data: res } = await RoleDeleteAjax(e.roleId);
          if (res.code !== 200)
            return this.$message({
              type: "error",
              message: res.msg
            });
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.getRoleListsAjax();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 修改开关状态
    switch_value_btn(row) {
      let text = row.status === "0" ? "显示" : "隐藏";
      this.$confirm(
        '确认要"' + text + '""' + row.roleName + '"菜单吗?',
        "警告",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(async () => {
          const { data: res } = await changeRoleStatus(row.roleId, row.status);
          if (res.code !== 200) {
            row.status = row.status === "0" ? "1" : "0";
            return this.$message({
              type: "error",
              message: res.msg
            });
          }
          this.$message({
            type: "success",
            message: res.msg
          });
        })
        .catch(() => {
          row.status = row.status === "0" ? "1" : "0";
        });
    },
    // 数据权限按钮
    Datapermission(row) {
      this.dialogVisibleData = true;
      this.roleDeptTreeselectAjax(row);
      this.getRoleAjax(row);
    },
    // 新增树形选中回调
    handleCheckChangeOne(data, checked, checkedKeys) {
      this.sizeForm.menuIds = checked.checkedKeys;
      // var menuIds = [];
      // var deleteStr = [];
      // if (checked) {
      //   function foo(data) {
      //     if (data.id) {
      //       if (menuIds.indexOf(data.id) == -1) {
      //         menuIds.push(data.id);
      //       }
      //     }
      //     if (data.children) {
      //       data.children.forEach(item => {
      //         menuIds.push(item.id);
      //         if (item.children) {
      //           foo(item);
      //         }
      //       });
      //     }
      //   }
      //   foo(data);
      //   menuIds.map(item => {
      //     if (this.sizeForm.menuIds.indexOf(item) == -1)
      //       this.sizeForm.menuIds.push(item);
      //     // console.log(this.sizeForm.menuIds);
      //   });
      // } else {
      //   function foo(data) {
      //     if (data.id) {
      //       if (deleteStr.indexOf(data.id) == -1) {
      //         deleteStr.push(data.id);
      //       }
      //     }
      //     if (data.children) {
      //       data.children.forEach(item => {
      //         deleteStr.push(item.id);
      //         if (item.children) {
      //           foo(item);
      //         }
      //       });
      //     }
      //   }
      //   foo(data);
      //   deleteStr.map(item => {
      //     // var index = this.sizeForm.menuIds.indexOf(item);
      //     // this.sizeForm.menuIds.splice(index, 1);
      //     this.sizeForm.menuIds.splice(this.sizeForm.menuIds.indexOf(item), 1);
      //     // console.log(this.sizeForm.menuIds);
      //   });
      // }
    },
    handleNodeClickTow(data, checked, indeterminate) {
      this.Form.deptIds = checked.checkedKeys;
      // var deptIds = [];
      // var deleteStr = [];
      // if (checked) {
      //   function foo(data) {
      //     if (data.id) {
      //       if (deptIds.indexOf(data.id) == -1) {
      //         deptIds.push(data.id);
      //       }
      //     }
      //     if (data.children) {
      //       data.children.forEach(item => {
      //         deptIds.push(item.id);
      //         if (item.children) {
      //           foo(item);
      //         }
      //       });
      //     }
      //   }
      //   foo(data);
      //   deptIds.map(item => {
      //     if (this.Form.deptIds.indexOf(item) == -1)
      //       this.Form.deptIds.push(item);
      //   });
      // } else {
      //   function foo(data) {
      //     if (data.id) {
      //       if (deleteStr.indexOf(data.id) == -1) {
      //         deleteStr.push(data.id);
      //       }
      //     }
      //     if (data.children) {
      //       data.children.forEach(item => {
      //         deleteStr.push(item.id);
      //         if (item.children) {
      //           foo(item);
      //         }
      //       });
      //     }
      //   }
      //   foo(data);
      //   deleteStr.map(item => {
      //     var index = this.Form.deptIds.indexOf(item);
      //     this.Form.deptIds.splice(index, 1);
      //   });
      // }
    },
    // 取消按钮
    cancelDataScope() {
      this.dialogVisibleData = false;
      this.dialogVisible = false;
      this.Form = {
        roleName: "",
        dataScope: "",
        deptIds: []
      };
      this.sizeForm = {
        roleName: "",
        roleSort: "",
        remark: "",
        status: "0",
        dataScope: "0",
        roleKey: "123",
        menuIds: []
      };
      this.roleList = [];
      this.menuList = [];
    },
    // 分页
    handleSizeChange(val) {
      this.formInline.pageSize = val;
      this.onSubmit();
    },
    handleCurrentChange(val) {
      this.formInline.pageNum = val;
      this.onSubmit();
    }
  }
};
</script>

<style lang="less" scoped>
.department_title {
  width: 72px;
  height: 24px;
  font-size: 18px;
  line-height: 24px;
  color: #171a1e;
  margin-bottom: 20px;
}
/deep/.demo-form-inline {
  .el-input__inner {
    width: 250px;
    height: 36px;
    font-size: 14px;
  }
  .left_margin {
    margin-left: 26px;
  }
  .inquire {
    width: 72px;
    height: 36px;
    margin-top: 2px;
    margin-left: -12px;
  }
  .el-button + .el-button {
    margin-left: 24px;
    width: 72px;
    height: 36px;
    background: #f6b439;
    border: 1px solid #f6b439;
  }
}
.newly_built {
  margin-top: 18px;
  margin-bottom: 20px;
  .newly_built_btn {
    width: 80px;
    height: 36px;
    text-align: center;
    padding: 0;
    background-color: #f6b439;
    border: 1px solid #f6b439;
  }
}
.operation_right {
  margin-right: 20px;
}

.el-tree {
  border: 1px solid #e1e1e1;
  border-radius: 4px;
}
// .el-form-item--mini.el-form-item {
//   margin-bottom: 24px;
//   height: 36px;
//   /deep/.el-form-item__content {
//     height: 36px;
//     .el-input--mini {
//       height: 36px;
//       input {
//         height: 36px;
//       }
//     }
//   }
// }
// .el-form-item--mini.el-form-item.WeChat {
//   height: auto;
// }
/deep/.el-table th {
  text-align: center;
  background-color: #f2f2f2;
}
/deep/ .el-table__row td {
  padding: 9px 0;
  text-align: center;
}
.dialog-footer {
  .add_new_btn {
    margin-left: 24px;
    background-color: #f6b439;
    border: 1px solid #f6b439;
  }
  .cancel {
    background: #f2f2f2;
    border: 1px solid #e1e1e1;
    border-radius: 4px;
  }
}
/deep/.el-dialog__header {
  .el-dialog__title {
    font-weight: normal;
  }
}
/deep/.el-form-item--mini .el-form-item__label {
  font-weight: normal;
  font-size: 16px;
}
/deep/.el-dialog {
  border-radius: 10px;
  padding: 10px 16px;
  .el-dialog__headerbtn {
    top: 36px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #000;
  }
}
/deep/.el-input--mini .el-input__inner {
  height: 32px;
  line-height: 36px;
  font-size: 16px;
}
/deep/.el-range-separator {
  width: 10%;
}
/deep/.el-range-editor.el-input__inner {
  float: left;
  margin-top: 2px;
}

/deep/ .el-date-editor .el-range__close-icon {
  line-height: 30px;
}
/deep/.el-date-editor .el-range-separator {
  line-height: 28px;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #f6b439;
  background: #f6b439;
  width: 24px;
  height: 24px;
}
/deep/.el-radio__label {
  font-size: 16px;
}
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #f6b439;
}
/deep/.el-radio__inner {
  width: 24px;
  height: 24px;
}
/deep/.el-radio__inner::after {
  width: 10px;
  height: 10px;
}
.el-dialog__footer {
  button {
    text-align: center;
    line-height: 13px;
    width: 72px;
    height: 36px;
  }
}
.paging {
  margin-top: 40px;
  margin-left: 610px;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #f6b439;
}
</style>
